import { combineReducers } from "redux";

import settings from "./settings/reducer";
import menu from "./menu/reducer";
import authUser from "./auth/reducer";
import user from "./user/reducer";
import doctors from "./doctors/reducer";
import patients from "./patients/reducer";
import kits from "./kits/reducer";
import holded from "./holded/reducer";
import stripe from "./stripe/reducer";

const reducers = combineReducers({
  settings,
  menu,
  authUser,
  user,
  doctors,
  patients,
  kits,
  holded,
  stripe,
});

export default reducers;
